<template>
  <div class="mb_controller_home h-100">
    <!-- <DesktopInterstitial v-if="desktop" />
    <MobileInterstitial v-if="mobile" /> -->
    <VodMastheadRails />

    <div class="position-relative main-list-wrapper">
      <div class="main-list-section d-flex justify-content-center flex-column">
        <HomepageContinueWatching
          class="mt-5 mb-3"
          v-if="initializeContinueWatchingRails"
        />
        <FavoriteRails v-if="initializeFavoriteRailes" class="my-4" />
        <DramaRails class="my-4" />
        <PopularVodV2 class="my-4" />
        <EksklusifRails class="my-4" />
        <!-- ads -->
        <div class="w-100">
          <billboardBannerTop v-if="desktop" class="my-3"></billboardBannerTop>
          <mrecBannerTop v-if="mobile" class="my-3"></mrecBannerTop>
        </div>

        <TelefilemRails />
        <!-- category listing -->
        <div
          class="w-100"
          v-for="(items, index) in category_list"
          :key="'cat_id' + index"
        >
          <VodRailsLandscapeNew
            :cat_id="items.id"
            :datasource="'vod'"
            :cat="convertStringToLower(items.value['en_US'].replace(/\s/g, ''))"
            :title="items.value['en_US']"
            :show_rails="false"
          />
          <div class="w-100" v-if="index == 4">
            <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
            <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle>
          </div>
        </div>

        <!-- ads bottom -->
        <billboardbannerbottom v-if="desktop"></billboardbannerbottom>
        <mrecbannerbottom v-if="mobile"></mrecbannerbottom>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import noimage from '../assets/noimage.png';
// v1
import VodMastheadRails from '../components/carousel/vod/v1/vodMastheadRails.vue';
// ads
import billboardBannerTop from '../components/ads/vod/billboardBannerTop';
import mrecBannerTop from '../components/ads/vod/mrecBannerTop';
import billboardBannerMiddle from '../components/ads/vod/billboardBannerMiddle';
import mrecBannerMiddle from '../components/ads/vod/mrecBannerMiddle';
import BillboardBannerBottom from '../components/ads/vod/billboardBannerBottom';
import MrecBannerBottom from '../components/ads/vod/mrecBannerBottom';
// import DesktopInterstitial from "../components/ads/interstitial/desktopInterstitial.vue";
// import MobileInterstitial from "../components/ads/interstitial/mobileInterstitial.vue";
// others
import VodRailsLandscapeNew from '../components/rails/vod_rails_landscape_new.vue';
// import DramaRails from "../components/carousel/vod/v1/dramaRails.vue";
import TelefilemRails from '../components/carousel/vod/v2/telefilemRails.vue';
// maintainance
// import MaintainanceDesktop from "../components/ads/maintainance/leaderboardTop.vue";
// import MaintainanceMobile from "../components/ads/maintainance/mobileMidRec.vue";
// v2 rails
import HomepageContinueWatching from '../components/carousel/homepageContinueWatching.vue';
import FavoriteRails from '../components/carousel/vod/v2/favoriteRails.vue';
import PopularVodV2 from '../components/carousel/homepage/v2/popularVod.vue';
import DramaRails from '../components/carousel/homepage/v2/dramaRails.vue';
import EksklusifRails from '../components/carousel/homepage/v2/eksklusifRails.vue';

import axios from 'axios';
export default {
  data: function() {
    return {
      vod: [],
      vod_each: [],
      news: [],
      specials: [],
      trending: [],
      vod_episodes: [],
      noimage: noimage,
      category_list: [],
      categories: [
        // "Covid-19",
        'News',
        'Exclusives',
        'Catch Up',
        'Documentary',
        'Drama',
        'Education',
        'Entertainment',
        'Festival',
        'Magazine',
        'Nostalgia',
        'Religious',
        'Variety',
      ],
      categories_id: [
        // "846",
        '212',
        '716',
        '746',
        '703',
        '728',
        '740',
        '717',
        '885', //kt sini festival
        '715',
        '749',
        '718',
        '726',
      ],
      tablet: false,
      mobile: false,
      desktop: false,
      initializeContinueWatchingRails: false,
      initializeFavoriteRailes: false,
    };
  },
  components: {
    billboardBannerTop: billboardBannerTop,
    mrecBannerTop: mrecBannerTop,
    billboardBannerMiddle: billboardBannerMiddle,
    mrecBannerMiddle: mrecBannerMiddle,
    billboardbannerbottom: BillboardBannerBottom,
    mrecbannerbottom: MrecBannerBottom,
    VodRailsLandscapeNew,
    VodMastheadRails,
    TelefilemRails,
    HomepageContinueWatching,
    PopularVodV2,
    FavoriteRails,
    DramaRails,
    EksklusifRails,
    // DesktopInterstitial,
    // MobileInterstitial,
    // MaintainanceDesktop,
    // MaintainanceMobile,
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($('.owl-carousel .item').length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          768: {
            items: 2,
            stagePadding: 0,
            loop: false,
          },
          991: {
            items: 5,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    installTrendingOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($('.owl-carousel .item').length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          991: {
            items: 3,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    goTo(link) {
      this.$router.push(link);
    },
    goToBanner(link) {
      this.$router.push(link);
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      if (item.idSchema == '205' || item.idSchema == '206') {
        //vod
        link =
          '/play?scheme=' +
          item.idSchema +
          '&p_type=true&id=' +
          item.id +
          '&eps_id=';
      } else if (item.idSchema == '205') {
        //vod
        link =
          '/play?scheme=' +
          item.idSchema +
          '&p_type=true&id=' +
          item.id +
          '&eps_id=';
      } else if (item.idSchema == '207') {
        //news
        link =
          '/play?scheme=' +
          item.idSchema +
          '&p_type=true&id=' +
          item.id +
          '&eps_id=';
      } else if (item.idSchema == '208') {
        //vod
        link =
          '/play?scheme=' +
          item.idSchema +
          '&p_type=true&id=' +
          item.id +
          '&eps_id=';
      } else if (item.idSchema == '209') {
        //news
        idSchema = '209';
        link = '/play?scheme=209&p_type=false&id=' + item.id + '&eps_id=';
      }

      return link;
    },
    filterBasedOnCategory() {
      var obj = this.vod;
      var categories = this.categories;
      var each = {};
      // this.vod_each;
      obj.forEach((items) => {
        var content_type = items.data.content_type;

        if (content_type.length != 0) {
          content_type.forEach((items_cat) => {
            for (var i = 0; i < categories.length; i++) {
              if (
                items_cat.title.en_US === categories[i] ||
                items_cat.title.en_US ===
                  this.convertStringToLower(categories[i]) ||
                items_cat.title.en_US ===
                  this.convertStringToLower(categories[i].replace(/\s/g, ''))
              ) {
                // console.log(this.convertStringToLower(categories[i].replace(/\s/g, "")));
                if (
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ''))
                  ]
                ) {
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ''))
                  ].push(items);
                } else {
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ''))
                  ] = [items];
                }
              }
            }
          });
        }
      });
      this.vod_each.push(each);
    },
    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    initializepageview() {
      var self = this;
      // console.log(this.$route.path);
      $.ajax({
        type: 'POST',
        url: 'https://rtm.glueapi.io/report/page-view',
        contentType: 'application/json',
        data: JSON.stringify({
          href: self.$route.path,
          title: 'vod',
          site: 'RTMKlik',
        }),
        dataType: 'json',
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    sortCategories(obj) {
      // this.category_list
      var category_id = [];
      obj.forEach((element) => {
        if (
          element.id != 335 &&
          element.id != 377 &&
          element.id != 577 &&
          element.id != 497 &&
          element.id != 583 &&
          element.id != 615 &&
          element.id != 576 &&
          element.id != 365 &&
          element.id != 1020 &&
          element.id != 582
        ) {
          category_id.push(element);
        }
      });

      //remove whole code from 370 to 381 when need to remove madani rails
      // Find the indices of the items
      const indexOf658 = category_id.findIndex((item) => item.id === 658);
      const indexOf2687 = category_id.findIndex((item) => item.id === 2687);

      if (indexOf658 !== -1 && indexOf2687 !== -1) {
        // Remove item with id 2687 from its original position
        const itemToMove = category_id.splice(indexOf2687, 1)[0]; // This will remove the item and return it

        // Insert it right after item with id 2468
        category_id.splice(indexOf658 + 1, 0, itemToMove);
      }

      this.category_list = category_id;
    },
    initializeCategoryForStart() {
      try {
        axios
          .get(`https://rtm.glueapi.io/v1/content-list/7`)
          .then((response) => {
            this.sortCategories(response.data.data.entries);
          });
      } catch (e) {
        console.log(e);
      }
    },
  },

  mounted() {
    this.deviceCheck();
    if (!this.$route.params.id) {
      setTimeout(
        function() {
          this.initializepageview();
        }.bind(this),
        700
      );
    }
  },

  beforeMount() {
    this.initializeCategoryForStart();

    const token = localStorage.getItem('token');
    const showFavorite = localStorage.getItem('setFavorite');
    if (token) {
      this.initializeContinueWatchingRails = true;
    }

    if (token && showFavorite) {
      this.initializeFavoriteRailes = true;
    }
  },
};
</script>

<style scoped>
.mb_controller_home {
  margin: 0 auto !important;
  padding-bottom: 140px;
  overflow-y: hidden;
}
.mb_controller_home:hover {
  z-index: 111;
  position: relative;
}
.pt-livetv {
  padding: 90px 0 0;
}
.breadCrumbsWrapper {
  padding: 30px;
}

@media only screen and (max-width: 768px) {
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
</style>
